import { lazy } from "react";

export { MY_TEAM_PATH } from "./path";
export const MyTeamPage = lazy(() => import("./page"));
